<script>

///Ultima alteração: 28/05/2020
///Alterado por: Allinne

    export let realty       = null;
    export let classStyle   = "list-cycle grid grid-size--1 grid-size-lg--2";
</script>

<ul class="features {classStyle}">
    {#each realty.RealtyFieldItems as field}
        <li class="feature feature--{field.CurrentType}">
            <p>{field.Title.toLowerCase()}{#if field.Value.toLowerCase() != "sim" && field.Value.toLowerCase() != "1"}: {field.Value}{/if}</p>
        </li>
    {/each}
</ul>

<style type="text/sass">
@import 'public/assets/sass/variables.sass'
p 
    text-transform: capitalize
    margin-bottom: 0

</style>